import React from 'react';
import FontTitle from '../../atoms/FontTitle';
import NewsList from '../../molecules/NewsList';
import InnerLink from '../../atoms/InnerLink';
import { MoreButton } from '../../atoms/Button';
import Anchor from '../../atoms/Anchor';
// CSSはインポートした順に生成され、後にインポートしたCSSの方が優先されるので、
// まず他のコンポーネントや共通CSSをインポートして、その後でコンポーネントごとのCSSをインストールすること
// つまり、styles.module.cssのインポートはインポート文の複数行のうちの最後に置いておくのが安全
import styles from './styles.module.css';

export type NewsAreaProps = {
};


const NewsArea : React.FC<NewsAreaProps> = () => {
    return (
        <div className={ styles['news-area'] }>
            <div className={styles['news-title-box']}>
                <div className={styles['news-title-inner']}>
                    <h2 className={styles['news-title']}><FontTitle>メモアカからの</FontTitle><FontTitle>お知らせ</FontTitle></h2>
                    <div className={styles['text-center']}><InnerLink to='/news'><MoreButton>一覧へ</MoreButton></InnerLink></div>
                </div>
            </div>

            <div className={styles['news-body']}>
                <div className={styles['news-wrap']}>
                  <NewsList date='2026.05.03'>「今月のチャレンジ 国旗国名記憶 ヨーロッパ編」コースを追加しました!</NewsList>
                </div>
                <div className={styles['news-wrap']}>
                  <NewsList date='2026.03.10'>「今月のチャレンジ 国旗国名記憶 アメリカ大陸編」コースを追加しました!</NewsList>
                </div>
                <div className={styles['news-wrap']}>
                  <NewsList date='2025.11.01'>「今月のチャレンジ 単位記憶」コースを追加しました!</NewsList>
                </div>
                <div className={styles['news-wrap']}>
                  <NewsList date='2025.10.03'>「今月のチャレンジ 国旗国名記憶 アフリカ編」コースを追加しました!</NewsList>
                </div>
                <div className={styles['news-wrap']}>
                  <NewsList date='2025.09.01'>「今月のチャレンジ 日本文学記憶」コースを追加しました!</NewsList>
                </div>
            </div>
        </div>
    );
};

export default NewsArea;
